<script lang="ts">
	import "bulma/css/versions/bulma-no-dark-mode.css";
	import "./lvwr.css";

	import { dldl, goto, yyyy, zzzz, syncOfflinePhotos } from "./store.svelte";
	import { toast } from "./lib/toast.svelte.ts";
	import getlivewires from "./extras/getlivewires.svelte";

	import Logo from "./Logo.svelte";
	import DevMenu from "./DevMenu.svelte";
	import Toast from "./lib/Toast.svelte";

	import Fa from "svelte-fa";
	import { faCode, faWifi, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
	import { onMount, tick } from "svelte";

	import Appcard from "./Appcard.svelte";
	import LearnMore from "./LearnMore.svelte";
	import SignIn from "./sign/In.svelte";
	import SignUp from "./sign/Up.svelte";
	import Usercard from "./Usercard.svelte";
	import Pricing from "./Pricing.svelte";
	import Costing from "./Costing.svelte";
	import UserManager from "./UserManager.svelte";
	import RiskPredictor from "./RiskPredictor.svelte";
	import Triage from "./Triage.svelte";
	import Waitlist from "./Waitlist.svelte";

	import UseCase from "./UseCase.svelte";
	import Slides from "./Slides.svelte";
	import Billing from "./Billing.svelte";
	import InvoiceView from "./InvoiceView.svelte";
	import Spotlight from "./applets/_/Spotlight/Spotlight.svelte";
	import CreateNewLivewire from "./create-new-livewire/CreateNewLivewire.svelte";
	import ScopeManager from "./ScopeManager.svelte";
	import Maplibre from "./charts/Maplibre.svelte";
	import NetworkInfo from "./applets/_/NetworkInfo/NetworkInfo.svelte";
	import Chronicle from "./applets/_/Chronicle/Chronicle.svelte";
	// import Gleo from "./charts/Gleo.svelte"

	import Controls from "./controls/Controls.svelte";
	import HelpTour from "./HelpTour.svelte";

	import posthog from "posthog-js";
	if (window.location.host.includes("lvwr.io")) {
		dldl("App.svelte", "posthog-js loading");
		posthog.init("phc_lPbScN4UuXuIN3zv7k3LXMlyAGKXvuHsdj2qWo6DAdX", {
			api_host: "https://us.i.posthog.com",
		});
	}
	//let isOnline: boolean = $state(true);
	//let Card = $state();

	yyyy.cards = [
		{ component: Appcard, active: false, uri: "/" },
		{ component: LearnMore, active: false, uri: "/learn-more" },
		{ component: SignIn, active: false, uri: "/sign-in" },
		{ component: SignUp, active: false, uri: "/sign-up" },
		{ component: Usercard, active: false, uri: "/livewires" },
		{ component: Pricing, active: false, uri: "/pricing" },
		{ component: Costing, active: false, uri: "/costing" },
		{ component: UserManager, active: false, uri: "/user-manager" },
		{ component: RiskPredictor, active: false, uri: "/risk-predictor" },
		{ component: Triage, active: false, uri: "/triage" },
		{ component: CreateNewLivewire, active: false, uri: "/create-new-livewire" },
		{ component: ScopeManager, active: false, uri: "/scope-manager" },
		{ component: Waitlist, active: false, uri: "/schedule-a-demo" },
		{ component: UseCase, active: false, uri: "/use-cases" },
		{ component: Slides, active: false, uri: "/slides" },
		{ component: Billing, active: false, uri: "/billing" },
		{ component: InvoiceView, active: false, uri: "/invoice" },
	];

	let route = () => {
		console.log("routing...");
		console.log(window.location.pathname);
		goto(window.location.pathname);
	};

	// Track previous online status for sync detection
	let wasOffline = !yyyy.isOnline;
	
	// Watch for online status changes and sync when coming online
	$effect(() => {
		if (yyyy.isOnline && wasOffline) {
			console.log('Device came back online, syncing offline data...');
			syncOfflinePhotos();
			// Add other sync functions here as needed
		}
		wasOffline = !yyyy.isOnline;
	});

	let showSearch = $state(false);
	let searchQuery = $state("");
	let searchInput: HTMLInputElement;

	const handleKeydown = async (e: KeyboardEvent) => {
		const onLivewires = yyyy.cards.find((c: any) => c.uri === '/livewires')?.active;
		if (e.key === "/" && !yyyy.sesh.activeLivewire && yyyy.sesh.logtoken && onLivewires && !showSearch) {
			const tag = (e.target as HTMLElement)?.tagName;
			if (tag === "INPUT" || tag === "TEXTAREA") return;
			e.preventDefault();
			showSearch = true;
			await tick();
			searchInput?.focus();
		}
		if (e.key === "Escape" && showSearch) {
			showSearch = false;
			searchQuery = "";
		}
	};

	const closeSearch = () => {
		showSearch = false;
		searchQuery = "";
		yyyy.livewireFilter = "";
	};

	const handleClick = (e: MouseEvent) => {
		if (!showSearch) return;
		const dialog = document.getElementById("search-dialog");
		if (dialog && !dialog.contains(e.target as Node)) {
			closeSearch();
		}
	};

	$effect(() => {
		yyyy.livewireFilter = searchQuery.trim().toLowerCase();
	});

	$effect(() => {
		if (yyyy.sesh.activeLivewire) {
			closeSearch();
		}
	});

	let matchCount = $derived(
		yyyy.livewireFilter && yyyy.livewires
			? yyyy.livewires.filter((lw: any) => lw.livewire?.toLowerCase().includes(yyyy.livewireFilter)).length
			: null
	);

	// Grid centering logic: flex-center when items don't fill a row, grid otherwise
	let carouselEl: HTMLElement;
	let carouselWidth = $state(0);
	let ro: ResizeObserver;

	let visibleCount = $derived(
		yyyy.livewires?.filter((lw: any) => !yyyy.livewireFilter || lw.livewire?.toLowerCase().includes(yyyy.livewireFilter)).length ?? 0
	);

	const GAP = 24; // 1.5rem
	const COL = 375;
	let colsFit = $derived(Math.floor((carouselWidth + GAP) / (COL + GAP)) || 1);
	let shouldCenter = $derived(visibleCount > 0 && visibleCount < colsFit);

	$effect(() => {
		if (carouselEl) {
			ro = new ResizeObserver(([entry]) => {
				carouselWidth = entry.contentRect.width;
			});
			ro.observe(carouselEl);
			return () => ro.disconnect();
		}
	});

	onMount(async () => {
		if (yyyy.sesh.logtoken) {
			delete yyyy.sesh.activeLivewire;
			delete yyyy.map.ident;
			delete yyyy.map.info;
			await getlivewires();
			// Only redirect to /livewires if on root; otherwise respect the URL
			const currentPath = window.location.pathname;
			if (currentPath === "/" || currentPath === "") {
				goto("/livewires");
			} else {
				goto(currentPath);
			}
			return;
		}
		const currentPath = window.location.pathname;
		console.log("currentPath", currentPath);
		goto(currentPath);
		dldl("App.svelte", "App.svelte mounted.");
	});
</script>

<svelte:window
	onpopstate={route}
	onkeydown={handleKeydown}
	onclick={handleClick}
	bind:online={yyyy.isOnline}
	onoffline={() => {
		toast.error("Network unreachable");
	}}
	ononline={() => {
		toast.info("Back online!!");
		// Trigger immediate sync when coming back online
		syncOfflinePhotos();
	}}
/>

<Toast />

{#if yyyy.map.engine === "Gleo"}
	<Gleo />
{/if}

{#if yyyy.map.engine === "Maplibre"}
	<Maplibre />
{/if}

{#if yyyy.sesh.activeLivewire}
	<Controls />
	{#if yyyy.ctrl.control === "NetworkInfo"}
		<div id="network-info-panel">
			<NetworkInfo />
		</div>
	{/if}
	{#if yyyy.ctrl.control === "Spotlight"}
		<div id="spotlight-panel">
			<Spotlight />
		</div>
	{/if}
	{#if yyyy.ctrl.control === "Chronicle"}
		<div id="chronicle-panel">
			<Chronicle />
		</div>
	{/if}
{/if}
<HelpTour />
<Logo usage="side" interact={false} />

{#if showSearch}
	<div id="search-dialog">
		<div class="search-input-wrapper">
			<Fa icon={faSearch} size="1.2x" color="#999" />
			<input
				type="text"
				placeholder="Filter livewires..."
				bind:value={searchQuery}
				bind:this={searchInput}
				onkeydown={(e) => { if (e.key === 'Escape') closeSearch(); }}
			/>
			{#if searchQuery}
				<button class="search-clear" onclick={() => { searchQuery = ""; searchInput?.focus(); }}>
					<Fa icon={faTimes} size="1x" />
				</button>
			{/if}
		</div>
		{#if matchCount === 0}
			<p class="search-no-results">No livewires found</p>
		{/if}
	</div>
{/if}

{#if yyyy.dev.showMenu}
	<DevMenu />
{:else if !yyyy.sesh.activeLivewire}
	<div
		id="card-carousel"
		class="columns is-centered is-multiline forced-hundred"
		class:center-items={shouldCenter}
		bind:this={carouselEl}
	>
		{#each yyyy.cards as Card (Card.uri)}
			{#if Card.active}{#if true}
					<Card.component />
				{/if}{/if}
		{/each}
	</div>
{/if}
<div id="annunciator">
	{#if !yyyy.isOnline}<Fa icon={faWifi} color="red" size="1x" />{/if}
	{#if yyyy.dev.isActive}
		<span
			aria-roledescription="show dev menu"
			role="button"
			tabindex="0"
			ondblclick={() => {
				yyyy.dev.showMenu = true;
			}}
		>
			<Fa icon={faCode} size="1x" color="grey" /></span
		>{/if}
</div>

<style>
	#card-carousel {
		position: fixed;
		display: grid !important;
		grid-template-columns: repeat(auto-fill, 375px);
		justify-content: center;
		align-content: start;
		top: 0;
		bottom: 0;
		overflow-y: auto;
		padding: 2em;
		padding-top: 4em;
		margin: 0 auto;
		max-width: 2850px;
		gap: 1.5rem;
	}

	#card-carousel.center-items {
		display: flex !important;
		flex-wrap: wrap;
		justify-content: center;
	}

	#annunciator {
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 5000;
	}

	.forced-hundred {
		width: 100vw;
		left: 0;
		right: 0;
	}


	#search-dialog {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 9999;
		width: 600px;
		max-width: 90vw;
		background: #ffffffee;
		border-radius: 10px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
		backdrop-filter: blur(20px);
		padding: 6px;
	}

	.search-input-wrapper {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 14px 18px;
	}

	.search-input-wrapper input {
		flex: 1;
		border: none;
		outline: none;
		font-size: 1.35rem;
		background: transparent;
		color: #363636;
		caret-color: #ff3e00;
	}

	.search-input-wrapper input::placeholder {
		color: #aaa;
	}

	.search-clear {
		background: none;
		border: none;
		cursor: pointer;
		color: #999;
		padding: 4px;
		display: flex;
		align-items: center;
	}

	.search-clear:hover {
		color: #ff3e00;
	}

	.search-no-results {
		text-align: center;
		color: #999;
		font-size: 1.1rem;
		padding: 12px 0 16px 0;
		margin: 0;
	}

	#network-info-panel,
	#spotlight-panel,
	#chronicle-panel {
		position: fixed;
		top: 15px;
		left: 15px;
		bottom: 15px;
		width: 35%;
		min-width: 450px;
		overflow-y: auto;
		z-index: 100;
		background-color: #ffffffee;
		border-radius: 8.775px;
		backdrop-filter: blur(20px) grayscale(0.8775);
	}
</style>
